export default function InElement(domParent, domCurrent) {
    do {
        if (domParent === domCurrent) {
            return true;
        }
    } while (domCurrent.parentElement && (domCurrent = domCurrent.parentElement));

    return false;
}
